import type { Rule } from './types.js';

export const DEFAULT_RULE: Rule = {
	param: 'category',
	values: [],
	operator: 'in',
};
